import * as React from 'react';

type MenuNoteContextType = {
  hasMenuNoteContext?: boolean;
};

export const MenuNoteContext = React.createContext<MenuNoteContextType>({});
